export default __webpack_public_path__ + "static/media/emptyCircledollar.adba74c6.svg";